mm.DrawerNavPage = function () {
  "use strict"

  var self = mm.DrawerPage($(".mm-drawer-wrap #nav"))

  self.showNested = function () {}

  return self
}
